import { Layers, EyeOff, UserMinus } from "lucide-react";

const problems = [
  {
    icon: Layers,
    title: "Tool Overload",
    description:
      "Your CRM is here, spreadsheets are there, recruiting lives in email, and training is on 4 different platforms. Nothing talks to each other.",
  },
  {
    icon: EyeOff,
    title: "No Visibility",
    description:
      "You have no idea how reps are actually performing until it's too late. Managers are flying blind with outdated spreadsheets.",
  },
  {
    icon: UserMinus,
    title: "Rep Turnover",
    description:
      "New reps quit in the first 30 days because onboarding is chaos, training is scattered, and nobody follows up.",
  },
];

export default function ProblemSection() {
  return (
    <section className="py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            Running a sales team on 6 different tools is{" "}
            <span className="text-destructive">broken</span>.
          </h2>
          <p className="text-lg text-muted-foreground">
            Sound familiar? You're not alone.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {problems.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                className="relative group rounded-xl border bg-card p-6 transition-all duration-200 hover:shadow-md hover:border-destructive/20"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-destructive/10">
                    <Icon className="h-5 w-5 text-destructive" />
                  </div>
                  <h3 className="font-semibold text-lg">{p.title}</h3>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed pl-14">
                  {p.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
